import { Head } from "@inertiajs/react"
import { CoverPage } from "@/components/VocationalTest/CoverPage"

interface Props {
  flash?: {
    notice?: string
    alert?: string
  }
}

export default function Home({ flash }: Props) {
  return (
    <>
      <Head title="Orientação Profissional - Teste Vocacional" />

      {flash?.notice && (
        <div className="mx-auto max-w-2xl mt-6 p-4 bg-green-100 text-green-800 rounded-lg">
          {flash.notice}
        </div>
      )}

      {flash?.alert && (
        <div className="mx-auto max-w-2xl mt-6 p-4 bg-red-100 text-red-800 rounded-lg">
          {flash.alert}
        </div>
      )}

      <CoverPage onFlip={() => {}} />
    </>
  )
}
